"use strict";

var _defineProperty = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var bip32 = _interopRequireWildcard(require("bip32"));

var bip39 = _interopRequireWildcard(require("bip39"));

var _exchangeRate = _interopRequireDefault(require("@oipwg/exchange-rate"));

var _insightExplorer = require("@oipwg/insight-explorer");

var _axios = _interopRequireDefault(require("axios"));

var _Coin = _interopRequireDefault(require("./Coin"));

var _networks = _interopRequireDefault(require("./networks"));

var _config = _interopRequireDefault(require("./networks/config"));

var _util = require("./util");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var DEFAULT_SUPPORTED_COINS = ['bitcoin', 'litecoin', 'flo', 'raven'];
var DEFAULT_SUPPORTED_TESTNET_COINS = ['bitcoinTestnet', 'floTestnet', 'litecoinTestnet', 'ravenTestnet'];

function sleep(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
}
/** Full Service [BIP44](https://github.com/bitcoin/bips/blob/master/bip-0044.mediawiki) Multi-Coin Wallet supporting both sending and receiving payments */


var Wallet = /*#__PURE__*/function () {
  /**
   * Create a new [BIP44](https://github.com/bitcoin/bips/blob/master/bip-0044.mediawiki) wallet with the supplied settings
   *
   * ##### Examples
   * Create wallet with Random Mnemonic
   * ```
   * let wallet = new Wallet()
   * ```
   * Create wallet from [BIP39](https://github.com/bitcoin/bips/blob/master/bip-0039.mediawiki) Mnemonic
   * ```
   * let wallet = new Wallet("abandon abandon abandon abandon abandon abandon abandon abandon abandon abandon abandon about")
   * ```
   * Create wallet from [BIP39](https://github.com/bitcoin/bips/blob/master/bip-0039.mediawiki) Entropy
   * ```
   * let wallet = new Wallet('00000000000000000000000000000000')
   * ```
   * Create wallet from Seed Hex
   * ```
   * let wallet = new Wallet("5eb00bbddcf069084889a8ab9155568165f5c453ccb85e70811aaed6f6da5fc19a5ac40b389cd370d086206dec8aa6c43daea6690f20ad3d8d48b2d2ce9e38e4")
   * ```
   * Create wallet from Seed Buffer
   * ```
   * let wallet = new Wallet(Buffer.from("5eb00bbddcf069084889a8ab9155568165f5c453ccb85e70811aaed6f6da5fc19a5ac40b389cd370d086206dec8aa6c43daea6690f20ad3d8d48b2d2ce9e38e4", "hex"))
   * ```
   *
   * @param  {string|Buffer} [seed] - [BIP39](https://github.com/bitcoin/bips/blob/master/bip-0039.mediawiki) Mnemonic, [BIP39](https://github.com/bitcoin/bips/blob/master/bip-0039.mediawiki) Entropy, or Seed Hex/Buffer
   * @param  {Object} [options] - Wallet settings
   * @param {boolean} [options.discover=false] - Defines if the Wallet should "auto-discover" Coin Account chains or not
   * @param {Array.<string>} [options.supportedCoins=['bitcoin', 'litecoin', 'flo']] - An Array of coins that the Wallet should support
   * @param {Array.<CoinInfo>} [options.networks] - An array containing a custom coins network info
   * @param {Object} [options.serializedData] - A previous Wallet state to reload from
   *
   * @example <caption>Create wallet using Mnemonic</caption>
   * let wallet = new Wallet("abandon abandon abandon abandon abandon abandon abandon abandon abandon abandon abandon about")
   *
   * @return {Wallet}
   */
  function Wallet(seed, options) {
    _classCallCheck(this, Wallet);

    // Check if seed is a string or buffer, if not, create a new BIP39 Mnemonic
    if ((0, _util.isMnemonic)(seed)) {
      this.fromMnemonic(seed);
    } else if ((0, _util.isEntropy)(seed)) {
      this.fromEntropy(seed);
    } else if (seed) {
      this.fromSeed(seed);
    } else {
      this.fromMnemonic(bip39.generateMnemonic());
    } // Derive the "m" level of the BIP44 wallet


    this.masterNode = bip32.fromSeed(Buffer.from(this.seed, 'hex')); // Set the networks to the imported defaults

    this.networks = _networks.default; // Check for custom coins/networks

    if (options && typeof options === 'object') {
      // Check if the user has defined their own supported coins for the wallet
      if (options.supportedCoins) {
        if (typeof options.supportedCoins === 'string') {
          this.supportedCoins = [options.supportedCoins];
        } else if (Array.isArray(options.supportedCoins)) {
          this.supportedCoins = options.supportedCoins;
        }
      } // Check if the user has defined any custom networks that should be imported


      if (options.networks && typeof options.networks === 'object') {
        // Attach each passed in network, overwrite if needed
        for (var node in options.networks) {
          if (!Object.prototype.hasOwnProperty.call(options.networks, node)) continue;
          this.networks[node] = options.networks[node];
        }
      }
    } // If we were not passed in a supported coin array by the options, then set it to the default options.


    if (!this.supportedCoins || !Array.isArray(this.supportedCoins)) {
      this.supportedCoins = DEFAULT_SUPPORTED_COINS;
    } // The array to hold the live coin objects


    this.coins = {}; // An optional variable to say if we should auto run address discovery on Account Chains

    if (options && (options.discover || options.discover === false)) {
      this.discover = options.discover;
    } else {
      this.discover = true;
    } // Attempt to deserialize if we were passed serialized data


    if (options && options.serializedData) {
      this.deserialize(options.serializedData);
    } // Add all coins


    var _iterator = _createForOfIteratorHelper(this.supportedCoins),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var coinName = _step.value;
        this.addCoin(coinName);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  _createClass(Wallet, [{
    key: "serialize",
    value: function serialize() {
      var serializedCoins = {};

      for (var name in this.coins) {
        serializedCoins[name] = this.coins[name].serialize();
      }

      return {
        masterNode: this.masterNode.toBase58(),
        seed: this.getMnemonic() ? this.getMnemonic() : this.seed,
        coins: serializedCoins
      };
    }
  }, {
    key: "deserialize",
    value: function deserialize(serializedData) {
      if (serializedData) {
        if (serializedData.coins) {
          for (var name in serializedData.coins) {
            if (!Object.prototype.hasOwnProperty.call(serializedData.coins, name)) continue;
            this.addCoin(name, {
              serializedData: serializedData.coins[name]
            });
          }
        }
      }
    }
    /**
     * Add a Coin to the Wallet
     * @param {String} name    - The coin "name" as defined in CoinInfo.name
     * @param {Object} [options] - Options you want passed to the coin being added
     */

  }, {
    key: "addCoin",
    value: function addCoin(name, options) {
      var opts = options || {};

      if (!opts.discover) {
        opts.discover = this.discover;
      } // If the coin isn't already added AND we have access to a valid network,
      // then add the coin.


      if (!this.coins[name] && this.networks[name]) {
        this.coins[name] = new _Coin.default(this.masterNode.derivePath('44\''), this.networks[name], opts);
      }
    }
    /**
     * Get a specific Coin
     * @param  {string} coin - The coin "name" as defined in CoinInfo.name
     * @example
     * let wallet = new Wallet();
     * let coin = wallet.getCoin("bitcoin")
     * @return {Coin} Returns the requested Coin
     */

  }, {
    key: "getCoin",
    value: function getCoin(coin) {
      for (var c in this.coins) {
        if (c === coin) {
          return this.coins[c];
        }
      }
    }
    /**
     * Get all Coins running inside the Wallet
     * @example
     * let wallet = new Wallet();
     * let coins = wallet.getCoins();
     * // coins = {
     * //  "bitcoin": Coin,
     * //  "litecoin": Coin,
     * //  "flo": Coin
     * // }
     * @return {Object.<number, Coin>} Object containing all coins
     */

  }, {
    key: "getCoins",
    value: function getCoins() {
      return this.coins;
    }
  }, {
    key: "GetCoinBalance",
    value: function () {
      var _GetCoinBalance = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(coin, options) {
        var balance;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return coin.getBalance(options);

              case 3:
                balance = _context.sent;
                _context.next = 9;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", {
                  error: new Error('Unable to get individual Coin Balance \n' + _context.t0)
                });

              case 9:
                return _context.abrupt("return", {
                  balance: balance
                });

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 6]]);
      }));

      function GetCoinBalance(_x, _x2) {
        return _GetCoinBalance.apply(this, arguments);
      }

      return GetCoinBalance;
    }()
    /**
     * Get Coin Balances
     * @param {Object} [options] - The options for searching the Balance of coins
     * @param  {Array} [options.coins=["bitcoin", "litecoin", "flo"]] - An array of coin names you want to get the balances for. If no coins are given, an array of all available coins will be used.
     * @param {Boolean} [options.discover=true] - Should we attempt a new discovery, or just grab the available balances
     * @param {Boolean} [options.testnet=true] - Should we attempt to get balances for testnet coins as well (coins ending with 'Testnet')
     *
     * @return {Promise<Object>} Returns a Promise that will resolve to an Object containing info about each coins balance, along with errors if there are any
     *
     * @example
     * let wallet = new Wallet(...)
     * wallet.getCoinBalances(["bitcoin", "litecoin", "flo"])
     *
     * //example return
     * {
     *      "flo": 2.16216,
     *      "bitcoin": "error fetching balance",
     *      "litecoin": 3.32211
     * }
     */

  }, {
    key: "getCoinBalances",
    value: function () {
      var _getCoinBalances = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var options,
            coinnames,
            i,
            coinPromises,
            _iterator2,
            _step2,
            name,
            coinBalances,
            coin,
            response,
            _args2 = arguments;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {
                  discover: true,
                  testnet: true
                };
                coinnames = options.coins || Object.keys(this.getCoins()); // when passing in custom options object, it's easy to forget to set the defaults, so just in case

                if (options.discover === undefined) {
                  options.discover = true;
                } // checking if false so that if undefined, it will proceed normally


                if (options.testnet === false) {
                  for (i = coinnames.length - 1; i >= 0; i--) {
                    if (coinnames[i].includes('Testnet')) {
                      coinnames.splice(i, 1);
                    }
                  }
                }

                coinPromises = {};
                _iterator2 = _createForOfIteratorHelper(coinnames);

                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    name = _step2.value;
                    coinPromises[name] = this.GetCoinBalance(this.getCoin(name), options);
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }

                coinBalances = {};
                _context2.t0 = _regeneratorRuntime.keys(coinPromises);

              case 9:
                if ((_context2.t1 = _context2.t0()).done) {
                  _context2.next = 17;
                  break;
                }

                coin = _context2.t1.value;
                _context2.next = 13;
                return coinPromises[coin];

              case 13:
                response = _context2.sent;

                if (typeof response.balance === 'number') {
                  coinBalances[coin] = response.balance;
                } else {
                  coinBalances[coin] = "error fetching balance: ".concat(JSON.stringify(response));
                }

                _context2.next = 9;
                break;

              case 17:
                return _context2.abrupt("return", coinBalances);

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getCoinBalances() {
        return _getCoinBalances.apply(this, arguments);
      }

      return getCoinBalances;
    }()
    /**
     * Calculate Exchange Rates for supported coins
     * @param {Object} [options] - The options for getting the exchange rates
     * @param {Array}  [options.coins=["bitcoin", "litecoin", "flo"]] - An array of coin names you want to get the balances for. If no coins are given, an array of all available coins will be used.
     * @param {String} [options.fiat="usd"] - The fiat type for which you wish to get the exchange rate for
     *
     * @return {Promise<Object>} Returns a Promise that will resolve to an Object containing info about each coins exchange rate, along with errors if there are any
     *
     * @example
     * let wallet = new Wallet(...)
     * wallet.getExchangeRates(["flo", "bitcoin", "litecoin"], "usd")
     *
     * //returns
     * {
     *      "flo": expect.any(Number) || "error",
     *      "bitcoin": expect.any(Number) || "error",
     *      "litecoin": expect.any(Number) || "error"
     * }
     */

  }, {
    key: "getExchangeRates",
    value: function () {
      var _getExchangeRates = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var options,
            coins,
            promiseArray,
            _iterator3,
            _step3,
            _coinname,
            rates,
            coinname,
            _args3 = arguments;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                options = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {
                  fiat: 'usd'
                };
                coins = options.coins || Object.keys(this.getCoins());

                if (coins) {
                  _context3.next = 4;
                  break;
                }

                throw new Error('No coins found to fetch exchange rates');

              case 4:
                if (!options.fiat) {
                  options.fiat = 'usd';
                } // Initialize an Exchange object


                if (!this.Exchange) {
                  this.Exchange = new _exchangeRate.default();
                }

                promiseArray = {};
                _iterator3 = _createForOfIteratorHelper(coins);
                _context3.prev = 8;

                _iterator3.s();

              case 10:
                if ((_step3 = _iterator3.n()).done) {
                  _context3.next = 17;
                  break;
                }

                _coinname = _step3.value;

                if (!_coinname.includes('Testnet')) {
                  _context3.next = 14;
                  break;
                }

                return _context3.abrupt("break", 17);

              case 14:
                promiseArray[_coinname] = this.Exchange.getExchangeRate(_coinname, options.fiat);

              case 15:
                _context3.next = 10;
                break;

              case 17:
                _context3.next = 22;
                break;

              case 19:
                _context3.prev = 19;
                _context3.t0 = _context3["catch"](8);

                _iterator3.e(_context3.t0);

              case 22:
                _context3.prev = 22;

                _iterator3.f();

                return _context3.finish(22);

              case 25:
                rates = {};
                _context3.t1 = _regeneratorRuntime.keys(promiseArray);

              case 27:
                if ((_context3.t2 = _context3.t1()).done) {
                  _context3.next = 40;
                  break;
                }

                coinname = _context3.t2.value;
                _context3.prev = 29;
                _context3.next = 32;
                return promiseArray[coinname];

              case 32:
                rates[coinname] = _context3.sent;
                _context3.next = 38;
                break;

              case 35:
                _context3.prev = 35;
                _context3.t3 = _context3["catch"](29);
                rates[coinname] = 'error fetching rate';

              case 38:
                _context3.next = 27;
                break;

              case 40:
                return _context3.abrupt("return", rates);

              case 41:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[8, 19, 22, 25], [29, 35]]);
      }));

      function getExchangeRates() {
        return _getExchangeRates.apply(this, arguments);
      }

      return getExchangeRates;
    }()
    /**
     * Calculate Balance of coins after exchange rate conversion
     * @param {Object} [options] - The options for getting the exchange rates
     * @param {Array}  [options.coins=["bitcoin", "litecoin", "flo"]] - An array of coin names you want to get the balances for. If no coins are given, an array of all available coins will be used.
     * @param {String} [options.fiat="usd"] - The fiat type for which you wish to get the exchange rate for
     * @param {Boolean} [options.discover=true] - Should we attempt a new discovery, or just grab the available balances
     * @param {Boolean} [options.testnet=true] - should we include testnet coins?
     * @return {Promise<Object>} Returns a Promise that will resolve to the fiat balances for each coin
     * @example
     * let wallet = new Wallet(...)
     * wallet.getFiatBalances(["flo", "bitcoin", "litecoin"], "usd")
     *
     * //returns
     * {
     *      "flo": expect.any(Number) || "error",
     *      "bitcoin": expect.any(Number) || "error",
     *      "litecoin": expect.any(Number) || "error"
     * }
     */

  }, {
    key: "getFiatBalances",
    value: function () {
      var _getFiatBalances = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(options) {
        var fiatBalances, balances, xrates, coinB, coinX, _iterator4, _step4, coinName;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                fiatBalances = {};
                balances = {};
                xrates = {};
                _context4.prev = 3;
                _context4.next = 6;
                return this.getCoinBalances(options);

              case 6:
                balances = _context4.sent;
                _context4.next = 12;
                break;

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4["catch"](3);
                throw new Error("Failed to get coin balances: ".concat(JSON.stringify(_context4.t0)));

              case 12:
                _context4.prev = 12;
                _context4.next = 15;
                return this.getExchangeRates(options);

              case 15:
                xrates = _context4.sent;
                _context4.next = 21;
                break;

              case 18:
                _context4.prev = 18;
                _context4.t1 = _context4["catch"](12);
                throw new Error("Failed to get exchange rates: ".concat(JSON.stringify(_context4.t1)));

              case 21:
                for (coinB in balances) {
                  for (coinX in xrates) {
                    if (coinB === coinX) {
                      // Both have been grabbed with no errors
                      if (!isNaN(balances[coinB]) && !isNaN(xrates[coinX])) {
                        fiatBalances[coinB] = balances[coinB] * xrates[coinX];
                      }
                    }
                  }
                } // Set the error state for coins not properly returned


                _iterator4 = _createForOfIteratorHelper(this.supportedCoins);

                try {
                  for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                    coinName = _step4.value;

                    if (!fiatBalances[coinName]) {
                      fiatBalances[coinName] = 'error';
                    }
                  }
                } catch (err) {
                  _iterator4.e(err);
                } finally {
                  _iterator4.f();
                }

                return _context4.abrupt("return", fiatBalances);

              case 25:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[3, 9], [12, 18]]);
      }));

      function getFiatBalances(_x3) {
        return _getFiatBalances.apply(this, arguments);
      }

      return getFiatBalances;
    }()
    /**
     * Init Wallet from BIP39 Mnemonic
     * @param  {string} mnemonic - A BIP39 Mnemonic String
     * @example
     * let wallet = new Wallet();
     * wallet.fromMnemonic("abandon abandon abandon abandon abandon abandon abandon abandon abandon abandon abandon about")
     * @return {Boolean} Returns if the operation was successful
     */

  }, {
    key: "fromMnemonic",
    value: function fromMnemonic(mnemonic) {
      if ((0, _util.isMnemonic)(mnemonic)) {
        this.mnemonic = mnemonic;
        this.entropy = bip39.mnemonicToEntropy(this.mnemonic);
        this.seed = bip39.mnemonicToSeedSync(this.mnemonic).toString('hex');
        return true;
      }

      return false;
    }
    /**
     * Get the [BIP39](https://github.com/bitcoin/bips/blob/master/bip-0039.mediawiki) Mnemonic, if defined
     * @example
     * let wallet = new Wallet('00000000000000000000000000000000');
     * let mnemonic = wallet.getMnemonic()
     * // mnemonic = "abandon abandon abandon abandon abandon abandon abandon abandon abandon abandon abandon about"
     * @return {string}
     */

  }, {
    key: "getMnemonic",
    value: function getMnemonic() {
      return this.mnemonic;
    }
    /**
     * Init Wallet from BIP39 Entropy
     * @param  {string} entropy - A BIP39 Entropy String
     * @example
     * let wallet = new Wallet();
     * wallet.fromEntropy('00000000000000000000000000000000')
     * @return {Boolean} Returns if the operation was successful
     */

  }, {
    key: "fromEntropy",
    value: function fromEntropy(entropy) {
      if ((0, _util.isEntropy)(entropy)) {
        this.entropy = entropy;
        this.mnemonic = bip39.entropyToMnemonic(this.entropy);
        return this.fromMnemonic(this.mnemonic);
      }

      return false;
    }
    /**
     * Get the Entropy value used to generate the [BIP39](https://github.com/bitcoin/bips/blob/master/bip-0039.mediawiki) Mnemonic.
     * Note that the Entropy will only be defined if we are creating
     * a wallet from Entropy or a Mnemonic, not off of just the Seed Hex
     *
     * @example
     * let wallet = new Wallet("abandon abandon abandon abandon abandon abandon abandon abandon abandon abandon abandon about");
     * let entropy = wallet.getEntropy()
     * // entropy = '00000000000000000000000000000000'
     * @return {string}
     */

  }, {
    key: "getEntropy",
    value: function getEntropy() {
      return this.entropy;
    }
    /**
     * Init Wallet from a Seed
     * @param  {string|Buffer} seed
     * @example
     * let wallet = new Wallet();
     * wallet.fromSeed("example-seed");
     * @return {Boolean} Returns if the operation was successful
     */

  }, {
    key: "fromSeed",
    value: function fromSeed(seed) {
      if (seed instanceof Buffer) {
        this.seed = seed.toString('hex');
        return true;
      } else if (typeof seed === 'string') {
        this.seed = seed;
        return true;
      }

      return false;
    }
    /**
     * Get the Encoded Seed hex string
     * @example
     * let wallet = new Wallet('00000000000000000000000000000000');
     * let seedHex = wallet.getSeed()
     * // seedHex = '5eb00bbddcf069084889a8ab9155568165f5c453ccb85e70811aaed6f6da5fc19a5ac40b389cd370d086206dec8aa6c43daea6690f20ad3d8d48b2d2ce9e38e4'
     * @return {string} The hex string of the seed buffer
     */

  }, {
    key: "getSeed",
    value: function getSeed() {
      return this.seed;
    }
    /**
     * @param  {Object} options - Options about the payment you wish to send
     * @param {OutputAddress|Array.<OutputAddress>} options.to - Define outputs for the Payment
     * @param {string|Array.<string>} [options.coin] - Define which coin you would like to send from
     * @param {string|Array.<string>} [options.from=All Addresses in Coin] - Define what public address(es) you wish to send from
     * @param {number|Array.<number>} [options.fromAccounts=All Accounts in Coin] - Define what Accounts on the Coin you wish to send from
     * @param {Boolean} [options.discover=true] - Should discovery happen before sending payment
     * @param {string} [options.floData=""] - Flo data to attach to the transaction
     * @return {Promise<string>} Returns a promise that will resolve to the success TXID
     */

  }, {
    key: "sendPayment",
    value: function () {
      var _sendPayment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(options) {
        var coinMatch, coin, allMatchCoin, _iterator5, _step5, toAdr, adr, _coin, _adr;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (options) {
                  _context5.next = 2;
                  break;
                }

                throw new Error('You must define payment options!');

              case 2:
                if (options.to) {
                  _context5.next = 4;
                  break;
                }

                throw new Error('You must define your payment outputs!');

              case 4:
                if (!options.coin) {
                  _context5.next = 17;
                  break;
                }

                if (!(typeof options.coin !== 'string')) {
                  _context5.next = 7;
                  break;
                }

                throw new Error('Send From Coin option must be the string name of the Coin!');

              case 7:
                if (!this.getCoin(options.coin)) {
                  _context5.next = 15;
                  break;
                }

                _context5.prev = 8;
                return _context5.abrupt("return", this.getCoin(options.coin).sendPayment(options));

              case 12:
                _context5.prev = 12;
                _context5.t0 = _context5["catch"](8);
                throw new Error(_context5.t0);

              case 15:
                _context5.next = 79;
                break;

              case 17:
                // If coin name is not passed, attempt to match addresses to a Coin!
                coinMatch = '';

                if (!Array.isArray(options.to)) {
                  _context5.next = 51;
                  break;
                }

                _context5.t1 = _regeneratorRuntime.keys(this.networks);

              case 20:
                if ((_context5.t2 = _context5.t1()).done) {
                  _context5.next = 49;
                  break;
                }

                coin = _context5.t2.value;
                allMatchCoin = true;
                _iterator5 = _createForOfIteratorHelper(options.to);
                _context5.prev = 24;

                _iterator5.s();

              case 26:
                if ((_step5 = _iterator5.n()).done) {
                  _context5.next = 38;
                  break;
                }

                toAdr = _step5.value;
                _context5.t3 = _regeneratorRuntime.keys(toAdr);

              case 29:
                if ((_context5.t4 = _context5.t3()).done) {
                  _context5.next = 36;
                  break;
                }

                adr = _context5.t4.value;

                if (Object.prototype.hasOwnProperty.call(toAdr, adr)) {
                  _context5.next = 33;
                  break;
                }

                return _context5.abrupt("continue", 29);

              case 33:
                if ((0, _util.isValidPublicAddress)(adr, this.networks[coin].network)) {
                  coinMatch = this.networks[coin].name;
                } else {
                  allMatchCoin = false;
                }

                _context5.next = 29;
                break;

              case 36:
                _context5.next = 26;
                break;

              case 38:
                _context5.next = 43;
                break;

              case 40:
                _context5.prev = 40;
                _context5.t5 = _context5["catch"](24);

                _iterator5.e(_context5.t5);

              case 43:
                _context5.prev = 43;

                _iterator5.f();

                return _context5.finish(43);

              case 46:
                // If not all addresses are valid, don't match to coin
                if (!allMatchCoin && coinMatch === this.networks[coin].name) {
                  coinMatch = '';
                }

                _context5.next = 20;
                break;

              case 49:
                _context5.next = 64;
                break;

              case 51:
                _context5.t6 = _regeneratorRuntime.keys(this.networks);

              case 52:
                if ((_context5.t7 = _context5.t6()).done) {
                  _context5.next = 64;
                  break;
                }

                _coin = _context5.t7.value;
                _context5.t8 = _regeneratorRuntime.keys(options.to);

              case 55:
                if ((_context5.t9 = _context5.t8()).done) {
                  _context5.next = 62;
                  break;
                }

                _adr = _context5.t9.value;

                if (Object.prototype.hasOwnProperty.call(options.to, _adr)) {
                  _context5.next = 59;
                  break;
                }

                return _context5.abrupt("continue", 55);

              case 59:
                if ((0, _util.isValidPublicAddress)(_adr, this.networks[_coin].network)) {
                  coinMatch = this.networks[_coin].name;
                }

                _context5.next = 55;
                break;

              case 62:
                _context5.next = 52;
                break;

              case 64:
                if (!(coinMatch !== '')) {
                  _context5.next = 78;
                  break;
                }

                if (!this.getCoin(coinMatch)) {
                  _context5.next = 75;
                  break;
                }

                _context5.prev = 66;
                return _context5.abrupt("return", this.getCoin(coinMatch).sendPayment(options));

              case 70:
                _context5.prev = 70;
                _context5.t10 = _context5["catch"](66);
                throw new Error(_context5.t10);

              case 73:
                _context5.next = 76;
                break;

              case 75:
                throw new Error('Cannot get Coin for matched network! ' + coinMatch);

              case 76:
                _context5.next = 79;
                break;

              case 78:
                throw new Error('Not all to addresses match any Coin network! Please check your outputs.');

              case 79:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[8, 12], [24, 40, 43, 46], [66, 70]]);
      }));

      function sendPayment(_x4) {
        return _sendPayment.apply(this, arguments);
      }

      return sendPayment;
    }()
    /**
     * Returns the network information for the coins available
     * @return Array.<CoinInfo>
     */

  }, {
    key: "getNetworks",
    value: function getNetworks() {
      return this.networks;
    }
  }, {
    key: "setNetworks",
    value: function setNetworks(networks) {
      this.networks = networks;
    }
    /**
     * Add default SUPPORTED testnet coins to wallet
     * @param {Boolean} [bool=true] - if true, add testnet coins, is false, remove them
     */

  }, {
    key: "addTestnetCoins",
    value: function addTestnetCoins() {
      var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (bool) {
        var _iterator6 = _createForOfIteratorHelper(DEFAULT_SUPPORTED_TESTNET_COINS),
            _step6;

        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var coinName = _step6.value;
            this.addCoin(coinName);
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
      } else {
        var _iterator7 = _createForOfIteratorHelper(DEFAULT_SUPPORTED_TESTNET_COINS),
            _step7;

        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var _coinName = _step7.value;
            delete this.coins[_coinName];
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }
      }
    }
    /**
     * Set the urls for the insight api explorers
     * @param options
     * @param {string} options.flo - flo api
     * @param {string} options.floTestnet - floTestnet api
     * @param {string} options.bitcoin - bitcoin api
     * @param {string} options.bitcoinTestnet - bitcoinTestnet api
     * @param {string} options.litecoin - litecoin api
     * @param {string} options.litecoinTestnet - litecoinTestnet api
     * @example
     * let options = {
     *     flo: 'myFloSiteApi.com/yadayada,
     *     bitcoin: 'myBitcoinApi.superApi/AyePeeEye',
     *     litecoin: 'superLightCoin.hero'
     * }
     * new Wallet(mnemonic, {discover: false}).setNetworkApi(options)
     */

  }, {
    key: "setExplorerUrls",
    value: function setExplorerUrls(options) {
      var networks = this.getNetworks();

      for (var networkCoin in networks) {
        for (var coin in options) {
          if (networkCoin === coin) {
            networks[coin].explorer = new _insightExplorer.Insight(options[coin]);
          }
        }
      }

      this.setNetworks(networks);
    }
    /**
     * Get back the network explorer apis for supported coins
     */

  }, {
    key: "getExplorerUrls",
    value: function getExplorerUrls() {
      var networks = this.getNetworks();
      var networkObject = {};

      for (var _i = 0, _Object$keys = Object.keys(this.getCoins()); _i < _Object$keys.length; _i++) {
        var walletCoin = _Object$keys[_i];

        for (var networkCoin in networks) {
          if (walletCoin === networkCoin) {
            networkObject[walletCoin] = networks[walletCoin].explorer.url;
          }
        }
      }

      return networkObject;
    }
  }, {
    key: "resetExplorerUrls",
    value: function resetExplorerUrls() {
      this.setExplorerUrls(_config.default.defaultApiUrls);
    }
  }, {
    key: "purchaseRecord",
    value: function () {
      var _purchaseRecord = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref) {
        var txid, terms, response, _response$data, validUntil, preImage, res, _res$data$results$0$r, amount, destination, account, mainAddress, publicAddress, paymentTxid, signature, body, res2;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                txid = _ref.txid, terms = _ref.terms;
                _context6.prev = 1;
                _context6.next = 4;
                return _axios.default.get("https://api.oip.io/oip/o5/location/request?id=".concat(txid, "&terms=").concat(terms));

              case 4:
                response = _context6.sent;
                _response$data = response.data, validUntil = _response$data.valid_until, preImage = _response$data.pre_image;
                _context6.next = 8;
                return _axios.default.get("https://api.oip.io/oip/o5/record/get/".concat(txid));

              case 8:
                res = _context6.sent;
                //! ask Bits about hard coding template.
                _res$data$results$0$r = res.data.results[0].record.details.tmpl_DE84D583, amount = _res$data$results$0$r.amount, destination = _res$data$results$0$r.destination;
                account = this.getCoin('flo').getAccount();
                mainAddress = account.getMainAddress(); // address with a balance

                publicAddress = mainAddress.getPublicAddress(); // send desired amount to to address

                _context6.next = 15;
                return account.sendPayment({
                  to: _defineProperty({}, destination, amount),
                  from: publicAddress
                });

              case 15:
                paymentTxid = _context6.sent;
                _context6.next = 18;
                return sleep(10000);

              case 18:
                // proof constructed by sining the request pre_image with address (that sent FLO)
                signature = mainAddress.signMessage(preImage);
                body = {
                  valid_until: validUntil,
                  id: txid,
                  term: terms,
                  pre_image: preImage,
                  signature: signature,
                  payment_txid: paymentTxid,
                  signing_address: publicAddress
                }; // location/request needs to be submitted

                _context6.next = 22;
                return _axios.default.post("https://api.oip.io/oip/o5/location/proof?id=".concat(txid, "&terms=").concat(terms), body);

              case 22:
                res2 = _context6.sent;
                return _context6.abrupt("return", res2.data);

              case 26:
                _context6.prev = 26;
                _context6.t0 = _context6["catch"](1);
                console.log(_context6.t0);

              case 29:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[1, 26]]);
      }));

      function purchaseRecord(_x5) {
        return _purchaseRecord.apply(this, arguments);
      }

      return purchaseRecord;
    }()
  }], [{
    key: "getDefaultExplorerUrls",
    value: function getDefaultExplorerUrls() {
      return _config.default.defaultApiUrls;
    }
  }]);

  return Wallet;
}();

module.exports = Wallet;